import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BsArrowsMove } from 'react-icons/bs';
import { FaTimes } from 'react-icons/fa';
import Button from '../../../elements/Button';
export default function ActionsButton({ onFloatBtnClick }) {
    return (_jsxs("div", { className: "float-molecule-actions", style: { display: 'flex', zIndex: 0 }, children: [_jsx(Button.Action, { style: { fontSize: '14px' }, fill: "clear", className: "handle", children: _jsx(BsArrowsMove, {}) }), _jsx(Button.Danger, { style: { fontSize: '14px' }, fill: "clear", onClick: onFloatBtnClick, children: _jsx(FaTimes, {}) })] }));
}
